import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const c = i((r, e) => /* @__PURE__ */ s.jsx(
  a,
  {
    ref: e,
    ...r,
    image: (l) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...l,
        children: [
          /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_2974_3432)", children: [
            /* @__PURE__ */ s.jsxs(
              "mask",
              {
                id: "mask0_2974_3432",
                width: 16,
                height: 16,
                x: 0,
                y: 0,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: [
                  /* @__PURE__ */ s.jsx(
                    "path",
                    {
                      fill: "currentColor",
                      d: "M8 16c-4.414 0-8-3.586-8-8s3.586-8 8-8 8 3.586 8 8-3.586 8-8 8M8 1.365A6.64 6.64 0 0 0 1.365 8 6.64 6.64 0 0 0 8 14.635 6.64 6.64 0 0 0 14.635 8 6.64 6.64 0 0 0 8 1.365"
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    "path",
                    {
                      fill: "currentColor",
                      d: "M7.281 12.332a.68.68 0 0 1-.673-.546c-.019-.082-.456-2.111-2.394-2.512a.697.697 0 0 1-.528-.81.674.674 0 0 1 .81-.528c1.21.255 2.02.929 2.54 1.62.545-1.793 1.729-4.341 4.268-5.788a.68.68 0 0 1 .928.255.68.68 0 0 1-.255.928c-3.495 2.002-4.023 6.717-4.023 6.762a.675.675 0 0 1-.646.61c-.009.01-.018.01-.027.01"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3432)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
          ] }),
          /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_2974_3432", children: /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
c.displayName = "AgencyCircleCheckmarkIcon";
export {
  c as AgencyCircleCheckmarkIcon,
  c as default
};
//# sourceMappingURL=index.js.map
